import {
  GRADE_K2_TIERED_INTERVENTIONS,
  GRADE_35_TIERED_INTERVENTIONS,
  GRADE_68_TIERED_INTERVENTIONS,
} from 'utils/productMaps'

/**
 * Creates a tab change handler function
 * @param {Object} params - Parameters for tab change
 * @param {Object} params.location - Current location object
 * @param {Function} params.navigationEvent - Navigation event handler
 * @returns {Function} The tab change handler function
 */
export const handleTabChange = ({ location, navigationEvent }) => {
  return tab => {
    const { search } = location || {}
    const destination = `${tab.route}?${new URLSearchParams(
      search,
    )?.toString()}`
    navigationEvent(destination)
  }
}

/**
 * Creates a back click handler function
 * @param {Object} params - Parameters for back navigation
 * @param {Function} params.navigationEvent - Navigation event handler
 * @returns {Function} The back click handler function
 */
export const handleBackClick = ({ navigationEvent, courseType }) => {
  let lessonsSlug = ''
  if (
    courseType === GRADE_K2_TIERED_INTERVENTIONS ||
    courseType === GRADE_35_TIERED_INTERVENTIONS
  ) {
    lessonsSlug = '/product/elementary/lessons'
  } else if (courseType === GRADE_68_TIERED_INTERVENTIONS) {
    lessonsSlug = '/product/middle-school/lessons'
  }

  return () => {
    navigationEvent(lessonsSlug)
  }
}

/**
 * Creates a header tab change handler function
 * @param {Object} params - Parameters for header tab change
 * @param {Array} params.tabSummaries - Array of available tab summaries
 * @param {Function} params.handleTabChange - Tab change handler function
 * @returns {Function} The header tab change handler function
 */
export const handleHeaderTabChange = ({ tabSummaries, handleTabChange }) => {
  return tab => {
    const originalTab = tabSummaries?.find(t => t?.displayTitle === tab?.title)
    handleTabChange(originalTab)
  }
}
